import { createSignal } from "solid-js";
import { Form, Row, Col } from "solid-bootstrap";
import { DeviceForm } from "./deviceform";
import timezones from "timezones-list";
import localeCodes from "locale-codes";



export function LocaleStage(props) {
    const [myDevice, setMyDevice] = createSignal(props.device);

    const readFormFields = (formDevice) => {
        const formTimezoneField = document.getElementById("formTimezone");
        const formTimezoneSelected = formTimezoneField.options[formTimezoneField.selectedIndex];
        formDevice["timezone"] = formTimezoneSelected.value;

        const formLocaleField = document.getElementById("formLocale");
        const formLocaleSelected = formLocaleField.options[formLocaleField.selectedIndex];
        formDevice["locale"] = formLocaleSelected.value;

        const formHourCycleOptionField = document.getElementById("formHourCycleOption");
        const formHourCycleSelected = formHourCycleOptionField.options[formHourCycleOptionField.selectedIndex];
        formDevice["hour_cycle_option"] = formHourCycleSelected.value;

        const formTemperatureOptionField = document.getElementById("formTemperatureOption");
        const formTemperatureSelected = formTemperatureOptionField.options[formTemperatureOptionField.selectedIndex];
        formDevice["temperature_option"] = formTemperatureSelected.value;

        const formLatitudeField = document.getElementById("device.latitude");
        formDevice["latitude"] = formLatitudeField.value;

        const formLongitudeField = document.getElementById("device.longitude");
        formDevice["longitude"] = formLongitudeField.value;

        const formLocationField = document.getElementById("device.location");
        formDevice["location"] = formLocationField.value;
    };

    const timezoneOptions = timezones.map((timezone) => {
        return { "label": timezone.name, "value": timezone.tzCode };
    });
    const prettyLocale = (locale) => {
        if (locale.location) {
            return `${locale.name} (${locale.location} - ${locale.tag})`;
        }
        return `${locale.name} (${locale.tag})`;
    }
    const locales = localeCodes.all.map((locale) => {
        return { "label": prettyLocale(locale), "value": locale.tag };
    });
    const hourCycleOptions = [
        { "label": "12-hour", "value": "h12" },
        { "label": "24-hour", "value": "h23" }
    ];
    const temperatureOptions = [
        { "label": "Celsius", "value": "c" },
        { "label": "Farenheit", "value": "f" }
    ];

    const latitudeRegex = `^[+-]?((\d+(\.\d*)?)|(\.\d+))$`;
    const longitudeRegex = `^^[+-]?((\d+(\.\d*)?)|(\.\d+))$`;
    const locationRegex = `^([a-zA-Z0-9_\\-][a-zA-Z0-9 _\\-]*)?[a-zA-Z0-9_\\-]$`;

    function validateFloatField(fieldId, min, max) {
        // Validate the field is a float and is within the min and max range
        // If not valid, set the field to invalid and return false
        const field = document.getElementById(fieldId);
        if (!field) {
            console.error(`Field ${fieldId} not found`);
            return false;
        }
        const value = parseFloat(field.value);
        if (isNaN(value) || value < min || value > max) {
            field.setCustomValidity(`Value must be a number between ${min} and ${max}`);
            field.reportValidity();
            return false;
        }
        return true;
    }

    function validate() {
        const isLatitudeValid = validateFloatField("device.latitude", -90, 90);
        const isLongitudeValid = validateFloatField("device.longitude", -180, 180);
        return isLatitudeValid && isLongitudeValid;
    }

    return <DeviceForm title="Locale and language" validate={validate} device={props.device} setDevice={setMyDevice} readFormFields={readFormFields} submitText="Save locale and language">

        <Row>
            <Col xs={12} md={6}>
                <Form.Group controlId="formTimezone">
                    <Form.Label>Timezone</Form.Label>
                    <Form.Select >
                        {timezoneOptions.map((option, index) =>
                            <>
                                <Show when={option["value"] === myDevice().timezone}>
                                    <option selected key={index} value={option["value"]}>{option["label"]}</option>
                                </Show>
                                <Show when={option["value"] !== myDevice().timezone}>
                                    <option key={index} value={option["value"]}>{option["label"]}</option>
                                </Show>
                            </>
                        )}
                    </Form.Select>
                </Form.Group>
            </Col>
        </Row>

        <Row>
            <Col xs={12} md={3}>
                <Form.Group controlId="formLocale">
                    <Form.Label>Locale</Form.Label>
                    <Form.Select>
                        {locales.map((option, index) =>
                            <>
                                <Show when={option["value"] === myDevice().locale}>
                                    <option selected key={index} value={option["value"]}>{option["label"]}</option>
                                </Show>
                                <Show when={option["value"] !== myDevice().locale}>
                                    <option key={index} value={option["value"]}>{option["label"]}</option>
                                </Show>
                            </>
                        )}
                    </Form.Select>
                </Form.Group>
            </Col>
        </Row>

        <Row>
            <Col xs={12} md={3}>
                <Form.Group controlId="formHourCycleOption">
                    <Form.Label>Hour Cycle Option</Form.Label>
                    <Form.Select>
                        {hourCycleOptions.map((option, index) =>
                            <>
                                <Show when={option["value"] === myDevice().hour_cycle_option}>
                                    <option selected key={index} value={option["value"]}>{option["label"]}</option>
                                </Show>
                                <Show when={option["value"] !== myDevice().hour_cycle_option}>
                                    <option key={index} value={option["value"]}>{option["label"]}</option>
                                </Show>
                            </>
                        )}
                    </Form.Select>
                </Form.Group>
            </Col>
        </Row>

        <Row>
            <Col xs={12} md={3}>
                <Form.Group controlId="formTemperatureOption">
                    <Form.Label>Temperature Option</Form.Label>
                    <Form.Select>
                        {temperatureOptions.map((option, index) =>
                            <>
                                <Show when={option["value"] === myDevice().temperature_option}>
                                    <option selected key={index} value={option["value"]}>{option["label"]}</option>
                                </Show>
                                <Show when={option["value"] !== myDevice().temperature_option}>
                                    <option key={index} value={option["value"]}>{option["label"]}</option>
                                </Show>
                            </>
                        )}
                    </Form.Select>
                </Form.Group>
            </Col>
        </Row>

        <Row>
            <Col xs={12} md={3}>
                <Form.Group controlId="device.latitude">
                    <Form.Label>Latitude</Form.Label>
                    <Form.Control
                        required
                        type="number"
                        placeholder="latitude"
                        step="any"
                        pattern={latitudeRegex}
                        value={myDevice().latitude}
                    />
                    <Form.Control.Feedback type="invalid">Device latitude required</Form.Control.Feedback>
                </Form.Group>
            </Col>
        </Row>

        <Row>
            <Col xs={12} md={3}>
                <Form.Group controlId="device.longitude">
                    <Form.Label>Longitude</Form.Label>
                    <Form.Control
                        required
                        type="number"
                        placeholder="longitude"
                        step="any"
                        pattern={longitudeRegex}
                        value={myDevice().longitude} />
                    <Form.Control.Feedback type="invalid">Device longitude required</Form.Control.Feedback>
                </Form.Group>
            </Col>
        </Row>

        <Row>
            <Col xs={12} md={3}>
                <Form.Group controlId="device.location">
                    <Form.Label>Location</Form.Label>
                    <Form.Control
                        required
                        type="text"
                        placeholder="location"
                        pattern={locationRegex}
                        value={myDevice().location} />
                    <Form.Control.Feedback type="invalid">Device location required</Form.Control.Feedback>
                </Form.Group>
            </Col>

        </Row>

    </DeviceForm>;
}